import { render } from "./rejectionDetail.vue?vue&type=template&id=49fea97a&scoped=true"
import script from "./rejectionDetail.vue?vue&type=script&lang=js"
export * from "./rejectionDetail.vue?vue&type=script&lang=js"

import "./rejectionDetail.vue?vue&type=style&index=0&id=49fea97a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fea97a"]])

export default __exports__